import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { HTTPError } from './http-error';
export var SCClient = /*#__PURE__*/function () {
  function SCClient(config) {
    _classCallCheck(this, SCClient);

    _defineProperty(this, "config", void 0);

    this.config = _Object$assign({}, config, {
      scUrl: config.scUrl.replace(/\/+$/, '')
    });
  }

  _createClass(SCClient, [{
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _body$timeToKill, _body$expiresAt, endpoint, response, body;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                endpoint = this.getEndpoint({
                  path: 'initialize'
                });
                _context.next = 4;
                return fetch(endpoint, SCClient.getRequestOptionsForGET({
                  headers: {
                    Accept: 'text/html'
                  }
                }));

              case 4:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context.next = 9;
                return response.json();

              case 9:
                body = _context.sent;
                return _context.abrupt("return", {
                  success: true,
                  state: {
                    accessToken: body.accessToken,
                    timeToKill: (_body$timeToKill = body.timeToKill) !== null && _body$timeToKill !== void 0 ? _body$timeToKill : null,
                    expiresAt: (_body$expiresAt = body.expiresAt) !== null && _body$expiresAt !== void 0 ? _body$expiresAt : null
                  }
                });

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  success: false,
                  error: SCClient.createErrorObject()
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function login() {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var endpoint, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                endpoint = this.getEndpoint({
                  path: 'logout'
                });
                _context2.next = 4;
                return fetch(endpoint, SCClient.getRequestOptionsForGET());

              case 4:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                return _context2.abrupt("return", {
                  success: true
                });

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  success: false
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "imAlive",
    value: function () {
      var _imAlive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _body$timeToKill2, _body$expiresAt2, endpoint, response, body;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                endpoint = this.getEndpoint({
                  path: 'imAlive'
                });
                _context3.next = 4;
                return fetch(endpoint, SCClient.getRequestOptionsForGET({
                  headers: this.config.enableSessionValidateMode ? {
                    'X-Authorization-Validate-Mode': '1'
                  } : undefined
                }));

              case 4:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context3.next = 9;
                return response.json();

              case 9:
                body = _context3.sent;
                return _context3.abrupt("return", {
                  success: response.ok,
                  state: {
                    accessToken: body.accessToken,
                    timeToKill: (_body$timeToKill2 = body.timeToKill) !== null && _body$timeToKill2 !== void 0 ? _body$timeToKill2 : null,
                    expiresAt: (_body$expiresAt2 = body.expiresAt) !== null && _body$expiresAt2 !== void 0 ? _body$expiresAt2 : null
                  }
                });

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](0);

                if (!(_context3.t0 instanceof HTTPError)) {
                  _context3.next = 17;
                  break;
                }

                throw _context3.t0;

              case 17:
                return _context3.abrupt("return", {
                  success: false,
                  state: {
                    accessToken: null,
                    timeToKill: null,
                    expiresAt: null
                  }
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 13]]);
      }));

      function imAlive() {
        return _imAlive.apply(this, arguments);
      }

      return imAlive;
    }()
  }, {
    key: "getEndpoint",
    value: function getEndpoint(_ref) {
      var path = _ref.path;
      return "".concat(this.config.scUrl, "/").concat(path);
    }
  }], [{
    key: "createErrorObject",
    value: function createErrorObject() {
      return {
        code: 'error.authentication.general',
        message: ''
      };
    }
  }, {
    key: "getRequestOptionsForGET",
    value: function getRequestOptionsForGET() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          headers = _ref2.headers;

      return {
        method: 'GET',
        headers: _Object$assign({
          Accept: 'application/json'
        }, headers),
        credentials: 'include'
      };
    }
  }]);

  return SCClient;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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